import { useState } from 'react';
import { CAPABILITIES } from '@lemontaigu/platform';
import { useCapability } from '@lemontaigu/platform-ui';
import { usePmsReach } from './PmsProvider.js';
import { fmtDate } from './logic.js';

// OB5 (PMS-OWNED-BOOKINGS-BRIEF §7.3) — « Remettre à zéro » the training
// établissement: its test bookings, clients and day closes go, its configuration
// stays, and its day is set back to today. Shown only to whoever holds
// pms.training.reset, and only for an établissement in mode `training` — the
// database refuses any other.

export function TrainingReset({ onDone }: { onDone: () => void }) {
  const can = useCapability(CAPABILITIES.PMS_TRAINING_RESET);
  const reach = usePmsReach();
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  const training = reach.filter((b) => b.property.mode === 'training');
  if (!can || training.length === 0) return null;

  const reset = async (code: string, label: string) => {
    if (
      !window.confirm(
        `Remettre à zéro « ${label} » ?\n\nToutes ses réservations de test, leurs clients et ses clôtures de journée ` +
          `seront effacés. Sa configuration reste. Ce qui a été encaissé ou facturé sur la chaîne école est conservé.`,
      )
    )
      return;
    const bundle = training.find((b) => b.property.code === code)!;
    setBusy(true);
    setMsg('');
    const r = await bundle.services.reservations.resetTraining(code);
    setBusy(false);
    if (!r.ok) return setMsg(`Erreur : ${r.error.message}`);
    setMsg(
      `${label} remis à zéro : ${r.value.reservations} réservation(s) et ${r.value.guests} client(s) effacés` +
        `${r.value.kept > 0 ? `, ${r.value.kept} conservée(s) (encaissées ou facturées)` : ''} · jour courant ${fmtDate(r.value.currentDay)}.`,
    );
    onDone();
  };

  return (
    <div className="pms-training-reset">
      {training.map((b) => (
        <button
          key={b.property.code}
          type="button"
          className="pms-chip"
          disabled={busy}
          onClick={() => void reset(b.property.code, b.property.labelFr)}
        >
          Remettre à zéro — {b.property.labelFr}
        </button>
      ))}
      {msg && <span className="pms-hint">{msg}</span>}
    </div>
  );
}
